import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import TireRepairIcon from '@mui/icons-material/TireRepair'
import N from 'utils/navigation'

export const TyreChangeCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <TireRepairIcon />,
        content: t('SetupWizard.TyreChangeSummary'),
        buttonText: t('SetupWizard.TyreChangeCTA'),
        actionOnClick: () => {
          N.push('/settings/tyre-change')
        }
      }}
    />
  )
}
